
  import {Component, Vue} from 'vue-property-decorator';
  import CookieDlg from "@/components/CookieDlg.vue";
  import Header from "@/components/Header.vue";
  import LandingSection from "@/components/LandingSection.vue";
  import $ from 'jquery';
  import TabSwitcher from "@/components/TabSwitcher";
  import Cookies from "js-cookie";
  import decryptHref from "@/components/EmailDecryptor";
  import {gaSendPageview} from "@/components/Analytics";

  @Component({
    components: {CookieDlg, LandingSection, Header}
  })
  export default class SupportLanding extends Vue {
    private adsSidebar300 = '';
    private adsSidebarTall = '';
    private readonly needsCookieConsent = Cookies.get("CookieConsent") !== "true";
    private tabSwitcher = new TabSwitcher();

    public $refs!: {
      cookieDlg: CookieDlg;
    };

    public mounted() {
      this.adsSidebar300 = document.getElementById('ads-sidebar-300-tmpl').innerHTML;
      this.adsSidebarTall = document.getElementById('ads-sidebar-tall-tmpl').innerHTML;
      this.tabSwitcher.init('general');
      if (this.needsCookieConsent) {
        this.$refs.cookieDlg.show();
      }
      gaSendPageview();
    }

    public decrypt(event: Event) {
      decryptHref($(event.target));
    }
  }
